import React from "react"
import { Button } from "../ui/base/button"
import Minus from "../icons/Minus"
import Plus from "../icons/Plus"
import { Input } from "../ui/base/input"
import { useSliceContext } from "../SliceProvider"
import { toHex } from "viem"
import { cn } from "@/src/lib/utils"

type Props = {
  productId: number
  size?: "sm" | "lg"
}

const CartButton = ({ productId, size = "sm" }: Props) => {
  const { isReady } = useSliceContext()
  const { cart, updateCart, theme } = useSliceContext()
  const { cartButtonColor } = theme

  const product = cart.find((p) => p.productId === productId)
  const quantity = product.quantity || 1
  const unitPrice = BigInt(product.price) / BigInt(quantity)

  const setQuantity = (newQuantity: number) => {
    const newCart = [...cart]
    const index = newCart.findIndex((p) => p.productId === productId)
    newCart[index].quantity = newQuantity
    newCart[index].price = toHex(unitPrice * BigInt(newQuantity))

    updateCart(newCart)
  }

  const buttonSize = size == "sm" ? "sl-w-8" : "sl-w-12"
  const maxQuantity = Math.min(
    !product.isInfinite ? product.availableUnits : Infinity,
    product.maxUnitsPerBuyer || Infinity
  )

  return (
    <div className="sl-flex">
      <Button
        variant="outline"
        size="icon"
        className={cn(
          `sl-h-7 ${buttonSize} sl-rounded-tr-none sl-rounded-br-none sl-border-r-0`,
          cartButtonColor
        )}
        disabled={!isReady || quantity <= 1}
        onClick={() => {
          setQuantity(quantity - 1)
        }}
      >
        <Minus className="sl-w-3.5 sl-h-3.5" />
      </Button>
      <Input
        type="number"
        min={1}
        max={maxQuantity}
        disabled={!isReady}
        className={cn(
          `${
            size == "sm" ? "sl-w-11 sl-text-xs" : "sl-w-24"
          } sl-text-center sl-rounded-none sl-px-2 sl-h-7 focus-visible:sl-ring-0`,
          cartButtonColor
        )}
        value={quantity || ""}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setQuantity(
            Number(
              e.target.value && e.target.value != "0"
                ? Number(e.target.value) > maxQuantity
                  ? maxQuantity
                  : e.target.value
                : 1
            )
          )
        }}
      />
      <Button
        variant="outline"
        size="icon"
        className={cn(
          `sl-h-7 ${buttonSize} sl-rounded-tl-none sl-rounded-bl-none sl-border-l-0`,
          cartButtonColor
        )}
        disabled={!isReady || quantity >= maxQuantity}
        onClick={() => {
          setQuantity(quantity + 1)
        }}
      >
        <Plus className="sl-w-3.5 sl-h-3.5" />
      </Button>
    </div>
  )
}

export default CartButton
